// @flow
import ProductMobileShare from './ProductMobileShare';

export default ProductMobileShare;



// WEBPACK FOOTER //
// ./src/components/product/ProductMobileShare/index.js